import { Property } from '@model';
import { MouseEvent as ReactMouseEvent, ReactNode, useState } from 'react';

const redirectApiBaseUrl = import.meta.env.VITE_REDIRECT_API_BASE_URL;

export type SocialShareLink = {
  title: string;
  href: string;
  icon: ReactNode;
  onClick?: (e: ReactMouseEvent<HTMLElement>) => void;
};

export const useSocialShareLinks: (
  property?: Property,
) => Array<SocialShareLink> = (property?: Property) => {
  const shareLink = property ? `${redirectApiBaseUrl}/${property?.id}` : '#';
  const title = property ? `${property.subCategory}, ${property.area}` : '';
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async (e: ReactMouseEvent<HTMLElement>) => {
    e.preventDefault();

    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return [
    {
      title: 'Copy Link',
      href: '#',
      icon: <i className={copied ? 'fas fa-check' : 'fas fa-link'}></i>,
      onClick: handleCopyLink,
    },
    {
      title: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`,
      icon: <i className='fab fa-facebook-f'></i>,
    },
    {
      title: 'Twitter',
      href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareLink)}&text=${encodeURIComponent(title)}`,
      icon: <i className='fab fa-twitter'></i>,
    },
    {
      title: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${encodeURIComponent(shareLink)}&title=${encodeURIComponent(title)}`,
      icon: <i className='fab fa-linkedin-in'></i>,
    },
    {
      title: 'Email',
      href: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareLink)}`,
      icon: <i className='fas fa-envelope'></i>,
    },
  ];
};
